import { PrestationType } from '@cpce/database/enums';
import { PRESTATION_TYPE_RULES } from '@cpce/shared';
import { Badge, BadgeColor } from '@/components/Badge';
import type { BadgeOption } from '@/components/table/table.types';

const TYPE_COLORS: Record<PrestationType, BadgeColor> = {
  remboursement: BadgeColor.ORANGE,
  billetterie: BadgeColor.GRAY,
  voyage: BadgeColor.GREEN,
  cheques: BadgeColor.PURPLE,
  adhesion: BadgeColor.BLUE,
};

export const PRESTATION_TYPE_BADGE_OPTIONS: BadgeOption<PrestationType>[] = Object.values(
  PrestationType
).map((value) => ({
  value,
  label: PRESTATION_TYPE_RULES[value].label,
  color: TYPE_COLORS[value],
}));

export function PrestationTypeBadge({ type }: { type: PrestationType }) {
  return <Badge color={TYPE_COLORS[type]}>{PRESTATION_TYPE_RULES[type].label}</Badge>;
}
